import Swiper from 'swiper';

// init Swiper:
new Swiper('.next-exhibitions__carousel', {
  slidesPerView: 'auto',
  spaceBetween: 30,
  watchOverflow: true,
  navigation: {
    nextEl: '.next-exhibitions__navigation .swiper-button-next',
    prevEl: '.next-exhibitions__navigation .swiper-button-prev',
  },
  pagination: {
    el: '.next-exhibitions__navigation .swiper-pagination',
    clickable: true,
  },
});

new Swiper('.next-exhibitions__current__carousel', {
  slidesPerView: 1,
  spaceBetween: 30,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  watchOverflow: true,
  pagination: {
    el: '.next-exhibitions__current__carousel .swiper-pagination',
    clickable: true,
  },
});
